/*
 * Menus du pied de page : accordeons sur mobile, toujours ouverts sur ordinateur.
 *
 * Le repli est assure par <details> natif — sans JS, le contenu reste donc
 * accessible au clic. Ce script se contente de forcer l'ouverture au-dessus de
 * 750px et de rendre le <summary> inerte a cette taille.
 */
(function () {
  const POINT_DE_BASCULE = window.matchMedia('(min-width: 750px)');

  function appliquer() {
    const surOrdinateur = POINT_DE_BASCULE.matches;
    document.querySelectorAll('[data-footer-accordion]').forEach(function (details) {
      if (surOrdinateur) {
        details.open = true;
      } else if (details.dataset.ouvertParUtilisateur !== 'true') {
        // On ne referme pas un accordeon que le visiteur vient d'ouvrir.
        details.open = false;
      }
    });
  }

  document.addEventListener('toggle', function (event) {
    const details = event.target.closest && event.target.closest('[data-footer-accordion]');
    if (!details || POINT_DE_BASCULE.matches) return;
    details.dataset.ouvertParUtilisateur = details.open ? 'true' : 'false';
  }, true);

  // Sur ordinateur le <summary> ne doit rien declencher.
  document.addEventListener('click', function (event) {
    const summary = event.target.closest && event.target.closest('.footer-block__summary');
    if (summary && POINT_DE_BASCULE.matches) event.preventDefault();
  });

  if (POINT_DE_BASCULE.addEventListener) POINT_DE_BASCULE.addEventListener('change', appliquer);
  else POINT_DE_BASCULE.addListener(appliquer); // Safari ancien

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appliquer);
  } else {
    appliquer();
  }
})();
